<template>
  <img
    v-if="url"
    :src="avatarUrl(url)"
    alt="user avatar"
    class="inline-block rounded-full border border-gray-300"
    :class="sizeClass"
  >
  <a-avatar
    v-else
    class="inline-flex justify-center items-center border border-gray-300"
    :class="sizeClass"
    icon="user"
  />
</template>

<script>
import { avatarUrl } from '@/lib/utils'
import { computed } from '@vue/composition-api'

export default {
  props: {
    url: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'small',
      validator(val) {
        return ['small', 'large'].includes(val)
      }
    }
  },

  setup(props) {
    return {
      avatarUrl,
      sizeClass: computed(() =>
        props.size === 'small' ? ['w-8', 'h-8'] : ['w-12', 'h-12']
      )
    }
  }
}
</script>